module.exports = __webpack_public_path__ + "static/nordic_7-ab8cf6eb0a4a99b1ac8cc6d45c82dd4f.jpg";